import { render, staticRenderFns } from "./DigitalProductItemWrap.vue?vue&type=template&id=6956db1a&scoped=true"
import script from "./DigitalProductItemWrap.vue?vue&type=script&lang=js"
export * from "./DigitalProductItemWrap.vue?vue&type=script&lang=js"
import style0 from "./DigitalProductItemWrap.vue?vue&type=style&index=0&id=6956db1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6956db1a",
  null
  
)

export default component.exports